import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { NotificationPanelGroup } from '@/models/Notification';
import NotificationPanelItems from '@/components/toolbar/notification/NotificationPanelItems.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPanelItemGroup',
  props: {
  group: {
    type: Object as PropType<NotificationPanelGroup>,
    required: true
  }
},
  setup(__props) {





return { __sfc: true,NotificationPanelItems }
}

})